<template>
  <div>
    <b-sidebar
      id="sidebar-right"
      ref="mySidebar"
      bg-variant="white"
      v-model="visibility"
      sidebar-class="sidebar-lg"
      right
      no-header
      backdrop
      shadow
    >
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">Manage Tax Category</h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="visibility = false"
        />
      </div>
      <b-form class="p-2" @submit.prevent>
        <b-row>
          <b-col md="12">
            <b-form-group
              label="Account"
              invalid-feedback="Account is required."
              ref="account"
            >
              <v-select
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :clearable="false"
                :options="accountOptions"
                :reduce="(opt) => opt.id"
                label="title"
                v-model="myObj.accountID"
                placeholder="Select account"
                @input="CheckAccount()"
              />
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-form-group
              label="Title"
              invalid-feedback="Title is required"
              ref="title"
            >
              <b-form-input
                placeholder="Enter tax category title"
                v-model.trim="myObj.title"
                @input="CheckTitle()"
              />
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-form-group
              label="Tax Percentage"
              invalid-feedback="Tax percentage must be greater than 0."
              ref="taxPerc"
            >
              <b-form-input
                type="number"
                step="0.01"
                min="0"
                placeholder="Enter tax percentage"
                v-model="myObj.taxPerc"
                @input="CheckTaxPerc()"
              />
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-button
              variant="success"
              @click="Add()"
              :disabled="request"
              block
            >
              <b-spinner v-if="request" small type="grow" />
              <span v-else>{{ $t("Save") }}</span>
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-sidebar>

    <b-card>
      <b-row class="mt-1">
        <b-col xl="2" lg="3" md="4" sm="12" cols="12">
          <b-button @click="AddOpen()" block variant="primary">
            <feather-icon icon="PlusIcon" class="mr-50" />
            <span class="align-middle">Tax Category</span>
          </b-button>
        </b-col>

        <b-col
          class="mt-lg-0 mt-md-0 mt-sm-1 mt-1"
          xl="10"
          lg="9"
          md="8"
          sm="12"
          cols="12"
        >
          <b-form-group class="">
            <b-input-group>
              <b-input-group-prepend is-text>
                <feather-icon icon="SearchIcon" />
              </b-input-group-prepend>

              <b-form-input
                v-model.trim="searchQuery"
                placeholder="Search tax categories..."
              />
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>

      <b-table
        class="mt-1"
        ref="selectableTable"
        :items="filters"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
        :busy="dataLoading"
        responsive
        show-empty
      >
        <template #table-busy>
          <div class="d-flex justify-content-center mb-3 mt-5">
            <b-spinner
              style="width: 3rem; height: 3rem"
              type="grow"
              variant="primary"
              label="Spinning"
            ></b-spinner>
          </div>
        </template>

        <template #cell(account)="data">
          <b-badge variant="light-primary">
            {{ getAccount(data.item.accountID) }}
          </b-badge>
        </template>

        <template #cell(title)="data">
          <b-badge variant="light-primary">
            {{ data.item.title }}
          </b-badge>
        </template>

        <template #cell(taxPerc)="data">
          <b-badge variant="light-success"> {{ data.item.taxPerc }}% </b-badge>
        </template>

        <template #head(actions)="data">
          <div class="text-center">
            <span>{{ data.label }}</span>
          </div>
        </template>

        <template #cell(actions)="data">
          <div class="text-center">
            <b-button
              variant="primary"
              v-b-tooltip.hover.left
              title="Edit"
              class="btn-icon mr-50"
              @click="Edit(data.item)"
            >
              <feather-icon icon="EditIcon" class="" />
            </b-button>

            <b-button
              variant="outline-danger"
              v-b-tooltip.hover.right
              title="Delete"
              class="btn-icon"
              @click="Delete(data.item.id)"
            >
              <feather-icon icon="Trash2Icon" />
            </b-button>
          </div>
        </template>
      </b-table>

      <b-col md="12" class="d-flex align-items-center justify-content-center">
        <b-pagination
          v-model="currentPage"
          :total-rows="filters.length"
          :per-page="perPage"
          first-number
          last-number
          class="mb-0 mt-1 mt-sm-0"
          prev-class="prev-item"
          next-class="next-item"
        >
          <template #prev-text>
            <feather-icon icon="ChevronLeftIcon" size="18" />
          </template>
          <template #next-text>
            <feather-icon icon="ChevronRightIcon" size="18" />
          </template>
        </b-pagination>
      </b-col>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BBadge,
  BPagination,
  BSpinner,
  BSidebar,
  BInputGroupPrepend,
  BInputGroup,
  BFormGroup,
  BForm,
  VBTooltip,
} from "bootstrap-vue";
import { mapActions } from "vuex";
import vSelect from "vue-select";

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BBadge,
    BPagination,
    BSpinner,
    BSidebar,
    BInputGroupPrepend,
    BInputGroup,
    BFormGroup,
    BForm,
    vSelect,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  data() {
    return {
      rights: {
        view: true,
        add: true,
        edit: true,
        delete: true,
      },
      request: false,
      visibility: false,
      dataLoading: false,
      searchQuery: "",
      currentPage: 1,
      perPage: 30,
      items: [],
      myObj: {
        id: 0,
        title: "",
        taxPerc: "",
        accountID: "",
        campusID: this.$store.state.userData.cId,
      },
      fields: [
        { label: "Title", key: "title" },
        { label: "Tax %", key: "taxPerc" },
        { label: "Account", key: "account" },
        { key: "actions", label: "Actions" },
      ],
      accountOptions: [],
    };
  },
  computed: {
    filters: function () {
      return this.items.filter((item) => {
        return (
          item.title.toLowerCase().match(this.searchQuery.toLowerCase()) ||
          item.taxPerc.toString().match(this.searchQuery)
        );
      });
    },
  },
  async created() {
    this.LoadAccounts();
    this.LoadData();
  },
  methods: {
    ...mapActions({ get: "get", post: "post", put: "put", delete: "delete" }),

    getAccount(id) {
      let obj = this.accountOptions.find((acc) => acc.id === id);
      return obj ? obj.title : "";
    },

    AddOpen() {
      this.myObj = {
        id: 0,
        title: "",
        taxPerc: "",
        accountID: "",
        campusID: this.$store.state.userData.cId,
      };
      this.visibility = true;
      var elem = this.$refs["title"];
      if (elem) elem.state = undefined;
      var elem = this.$refs["taxPerc"];
      if (elem) elem.state = undefined;
      var elem = this.$refs["account"];
      if (elem) elem.state = undefined;
    },

    Edit(item) {
      this.myObj = { ...item };
      this.visibility = true;
      var elem = this.$refs["title"];
      if (elem) elem.state = undefined;
      var elem = this.$refs["taxPerc"];
      if (elem) elem.state = undefined;
      var elem = this.$refs["account"];
      if (elem) elem.state = undefined;
    },

    CheckTitle() {
      var elem = this.$refs["title"];
      if (this.myObj.title.trim() == "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },

    CheckTaxPerc() {
      var elem = this.$refs["taxPerc"];
      let x = parseFloat(this.myObj.taxPerc);
      if (isNaN(x) || x <= 0) {
        return (elem.state = false);
      } else {
        this.myObj.taxPerc = x;
        return (elem.state = true);
      }
    },

    CheckAccount() {
      var elem = this.$refs["account"];
      if (!this.myObj.accountID) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },

    async Add() {
      const s1 = this.CheckAccount();
      const s2 = this.CheckTitle();
      const s3 = this.CheckTaxPerc();

      if (!s1) {
        return this.$bvToast.toast("Please select an account", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      }

      if (!s2) {
        return this.$bvToast.toast("Please enter tax category title", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      }

      if (!s3) {
        return this.$bvToast.toast("Tax percentage must be greater than 0", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      }

      if (this.myObj.id == 0) {
        // Add
        this.request = true;
        var status = await this.post({
          url:
            this.$store.state.domain +
            "taxCategories?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId,
          body: this.myObj,
          message: "Tax category added successfully.",
          context: this,
          token: this.$store.state.userData.token,
        });
        this.request = false;
        if (status) {
          this.LoadData();
          this.visibility = false;
        }
      } else {
        // Edit
        this.request = true;
        var status = await this.put({
          url:
            this.$store.state.domain +
            "taxCategories/" +
            this.myObj.id +
            "?db=" +
            this.$store.state.userData.db,
          body: this.myObj,
          message: "Tax category updated successfully.",
          context: this,
          token: this.$store.state.userData.token,
        });
        this.request = false;
        this.visibility = false;
        if (status) {
          this.LoadData();
          this.visibility = false;
        }
      }
    },

    async Delete(id) {
      let result = await Swal.fire({
        title: this.$t("Are you sure?"),
        text: this.$t("You won't be able to revert this!"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: this.$t("Yes, Delete it!"),
      });

      if (result.isConfirmed) {
        var status = await this.delete({
          url:
            this.$store.state.domain +
            "taxCategories/" +
            id +
            "?db=" +
            this.$store.state.userData.db,
          message: "Tax category removed successfully.",
          context: this,
          token: this.$store.state.userData.token,
        });
        if (status) this.LoadData();
      }
    },

    async LoadData() {
      this.dataLoading = true;
      var obj = {
        url:
          this.$store.state.domain +
          "taxCategories?db=" +
          this.$store.state.userData.db +
          "&cId=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.items = await this.get(obj);
      this.dataLoading = false;
    },

    async LoadAccounts() {
      var obj = {
        url:
          this.$store.state.domain +
          "Accounts/LoadData?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.accountOptions = await this.get(obj);
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
